// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KFJT","heroText":"styles_heroText__2CdKZ","modal":"styles_modal__ic7Aw","content":"styles_content__1c3KU"};